import { defineStore } from "pinia";
import { createBaseStoreRefactor } from "./baseStoreRefactor";

// Create base store configuration for day report types
const dayReportTypesBaseStore = createBaseStoreRefactor({
  endpoint: "/api/v1/day_report_types",
  name: "DayReportTypesStoreRefactor",
  objectName: "Dagrapport Type", // Auto-generates CRUD success messages
  enableCache: true, // Enable caching since types rarely change
  actionCableChannel: null, // No real-time updates needed
  infiniteLoading: false, // Simple list, no pagination needed
});

export const useDayReportTypesStoreRefactor = defineStore(
  "dayReportTypesRefactor",
  {
    ...dayReportTypesBaseStore,

    getters: {
      ...dayReportTypesBaseStore.getters,

      /**
       * Get all day report types (maps to state.data for compatibility)
       */
      dayReportTypes: (state) => {
        return state.data || [];
      },

      /**
       * Get type by ID
       */
      getTypeById: (state) => (id) => {
        return state.data.find((type) => type.id == id);
      },

      /**
       * Get active types only
       */
      getActiveTypes: (state) => {
        return (state.data || []).filter((type) => type.active !== false);
      },

      /**
       * Get types sorted by position
       */
      getSortedTypes: (state) => {
        return [...(state.data || [])].sort(
          (a, b) => (a.position || 0) - (b.position || 0),
        );
      },
    },

    actions: {
      ...dayReportTypesBaseStore.actions,

      /**
       * Move day report type up or down in position
       */
      async move({ item, direction }) {
        try {
          this.loading = true;
          console.log(
            `DayReportTypesStoreRefactor: Moving day report type ${item.id} ${direction}`,
          );

          // Use direct API call since customApiCall wraps data incorrectly for this endpoint
          const apiClient = (await import("@/services/apiClient")).default;
          const result = await apiClient.post(
            `/api/v1/day_report_types/${item.id}/move`,
            { direction },
            {},
            { successMessage: `Type is succesvol verplaatst` },
          );

          // Refresh the list to get updated positions
          await this.fetchAll({}, true);

          return result;
        } catch (error) {
          console.error(
            `DayReportTypesStoreRefactor: Error moving day report type ${item.id}:`,
            error,
          );
          throw error;
        } finally {
          this.loading = false;
        }
      },

      // All other methods including CRUD operations are fully inherited from base store
      // Auto-generated messages use "Type" from objectName
    },
  },
);
